<template>
  <v-app data-cy="app" >
    <!-- if no google or yandex or etc -->
    <HeaderToolbar  />

    <div class="router_and_banners_container">
      <router-view />
      <v-col class="advertisment-block pa-0 ml-2 d-none d-lg-block" v-if="lgAndUp">

        <Suspense v-if="page_load && !without_advert && !prerender ">
          <AdvertismentBlock />

          <template #fallback>
            <v-skeleton-loader v-if="!prerender" height="100vh" type="card@3" class="" />
          </template>
        </Suspense>

        </v-col>
      </div>

      <template v-if="page_load">
        <CookiesNotification />

        <v-lazy
          :model-value="prerender"
          :min-height="150"
          :options="{'threshold': 0.2}"
          transition="fade-transition"
        >
          <FooterToolbar  />
        </v-lazy>
      </template>

  </v-app>
</template>

<script>
// import { API_KEY, injectVKOpenApi, initVK } from "./vknt.js";

import { mapState } from 'vuex';

import { defineAsyncComponent } from 'vue';

const HeaderToolbar = defineAsyncComponent(() => import('./views/HeaderToolbar.vue'));
const AdvertismentBlock = defineAsyncComponent(() => import('./components/adverts/AdvertismentBlock.vue'));
const FooterToolbar = defineAsyncComponent(() => import('./views/FooterToolbar.vue'));
const CookiesNotification = defineAsyncComponent(() => import('./components/CookiesNotification.vue'));

import './scss/app.scss';

export default {
  name: 'App',
  computed: mapState({
    page_load: (state) => state.page_load,
    isMobile: (state) => state.isMobile,
    prerender: (state) => state.prerender,
    without_advert: (state) => state.without_advert,
  }),
  beforeCreate() {
    this.$store.dispatch("getInitialParams");
  },
  components: {
    HeaderToolbar,
    FooterToolbar,
    CookiesNotification,
    AdvertismentBlock
  },
  // mounted() {
  //   if (process.env.NODE_ENV == 'production' && !this.prerender) {
  //     window.vkAsyncInit = function() {
  //       window.pixel = new VK.Pixel(API_KEY);
  //     }
  //
  //     injectVKOpenApi()
  //       .then(initVK())
  //   }
  // },
	/* mounted() { */
	/* 	let chatScript = document.createElement('script'); */
	/* 	chatScript.setAttribute('src', 'https://code-ya.jivosite.com/widget/bUvlb8xT2y'); */
	/* 	setTimeout(() => { document.body.appendChild(chatScript) },10000); */
	/* } */
}
</script>

<script setup>

import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader'
import { useDisplay } from 'vuetify'

const { lgAndUp }= useDisplay();

</script>
